import axios from "axios";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";
import routes from "../../configs/api";

const getPackagesDetails = (filters = {}, newSearchValue = "") => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  return new Promise((resolve, reject) => {
    let URL = `${routes.PACKAGES_LIST}`;
    const params = new URLSearchParams();
    const isFilterObject = typeof filters === "object" && filters !== null;
    const selectedMonth = isFilterObject ? filters.month : filters;
    const search = isFilterObject ? filters.search : newSearchValue;

    if (selectedMonth && selectedMonth !== "") {
      params.set("month", selectedMonth);
    }
    if (isFilterObject && filters.startDate && filters.endDate) {
      params.set("startDate", new Date(filters.startDate).toISOString().split("T")[0]);
      params.set("endDate", new Date(filters.endDate).toISOString().split("T")[0]);
    }
    if (search && search !== "") {
      params.set("search", search);
    }

    params.set("_t", Date.now().toString());

    if ([...params].length > 0) {
      URL = `${URL}?${params.toString()}`;
    }

    axios
      .get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default getPackagesDetails;
